<template>
  <FITFormCard>
    <div slot="header">
      <b-row align-v="center">
        <b-col cols=8>
          <p class="h5">{{$t('crm.lead.header')+" "+$t('crm.lead.leadList')}}</p>
        </b-col>
        <b-col cols="4" class="text-right">
          <b-button v-if="permissionLevel < 5.5" variant="primary" size="md" @click="createNewLead">{{ $t('crm.lead.create.header') }}</b-button>
        </b-col>
      </b-row>
    </div>
    <div slot="formBody">
      <b-alert variant="success" dismissible :show="shouldShowSuccessMessage">
        <span class="h5"><i class="fa fa-check-circle mr-2"></i>{{ $t('crm.lead.create.success') }}</span>
      </b-alert>
      <!-- <b-row class="text-left ml-1">
        <b-col cols="2">
          <FITSelect :label="$t('crm.lead.create.type')" v-model="search.type" :options="leadTypes"></FITSelect>
        </b-col>
        <b-col cols="2">
          <FITSelect :label="$t('crm.lead.create.status')" v-model="search.status" :options="leadStatus"></FITSelect>
        </b-col>
        <b-col cols="2">
          <FITSelect :label="$t('crm.lead.create.level')" v-model="search.leadLevel" :options="leadLevels"></FITSelect>
        </b-col>
        <b-col cols="2">
          <FITDatePicker :label="$t('crm.lead.dateFrom')" v-model="search.dateFrom"></FITDatePicker>
        </b-col>
        <b-col cols="2">
          <FITDatePicker :label="$t('crm.lead.dateTo')" v-model="search.dateTo"></FITDatePicker>
        </b-col>
        <b-col cols="1">
          <FITButton :text="$t('crm.lead.clear')" @click="clearFilter" size="md" faIcon="fa-times-circle" variant="danger">
          </FITButton>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="6">
          <FITTextInput :label="$t('crm.lead.search')" :placeholder="$t('crm.lead.search')" v-model="search.search"></FITTextInput>
        </b-col>
        <b-col cols="auto" class="text-right ml-auto">
          <FITPagination :disabled="busy" :totalRows="data.total" :perPage="pagination.perPage" size="md" @input="onPageChanged"></FITPagination>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <b-table class="pointer-cursor" outlined fixed hover responsive :items="data.list" :fields="fields" @row-clicked="onRowSelected">
            <template slot="type" slot-scope="row">
              {{ getConvertedString('leadTypes', row.value) }}
            </template>
            <template slot="dateOfContact" slot-scope="row">
              {{ row.value | date }}
            </template>
            <template slot="name" slot-scope="row">
              {{ row.value }}
            </template>
            <template slot="status" slot-scope="row">
              {{ getConvertedString('leadStatus', row.value) }}
            </template>
            <template slot="createTime" slot-scope="row">
              {{ row.value }}
            </template>
            <template slot="updateTime" slot-scope="row">
              {{ row.value }}
            </template>
          </b-table>
        </b-col>
      </b-row>
      <b-row align-v="center">
        <b-col cols="10" class="text-left">
          <span class="text-secondary">{{ total }}</span>
        </b-col>
        <b-col cols="auto" class="text-right ml-auto">
          <FITPagination :disabled="busy" :totalRows="data.total" :perPage="pagination.perPage" size="md" @input="onPageChanged"></FITPagination>
        </b-col>
      </b-row> -->

       <FITSearchableTable :filters="filters" :actions="actions" :columns="columns" searchAction="getLeadList" vuexModule="Crm" type="lead" @onRowSelected="onRowSelected"></FITSearchableTable>
    </div>
  </FITFormCard>
</template>
<script type="text/javascript">
import {
  FITPagination,
  FITFormCard,
  FITSelect,
  FITButton,
  FITTextInput,
  FITDatePicker,
  FITSearchableTable
} from '@/components';
import Vue from 'vue';
import { mapGetters } from 'vuex';

export default {
  name: 'LeadList',
  components: {
    FITPagination,
    FITFormCard,
    FITSelect,
    FITButton,
    FITTextInput,
    FITDatePicker,
    FITSearchableTable
  },
  data() {
    return {

      filters:[{
          label: this.$t('crm.lead.create.type'),
          key: 'type',
          type: 'select',
          default: null, // Default All
        },
         {
          label: this.$t('crm.lead.create.leadLevel'),
          key: 'leadLevel',
          type: 'select',
          default: null, // Default All
        },
        {
          label: this.$t('crm.lead.create.status'),
          key: 'status',
          type: 'select',
          default: null, // Default All
        },
       
        ],
      actions:[],
      columns: [
        { key: 'type', label: this.$t('crm.lead.create.type'),sortable:true, formatter: (row, key, item) => {
          return this.getTranslated(key, row);
        } },
        { key: 'leadLevel', label: this.$t('crm.lead.create.leadLevel'),sortable:true, formatter: (row, key, item) => {
          return this.getTranslated(key, row);
        } },
        { key: 'dateOfContact', label: this.$t('crm.lead.create.dateOfContact'),sortable:true},
        { key: 'name', label: this.$t('crm.lead.create.name') },
        { key: 'status', label: this.$t('crm.lead.create.status') ,sortable:true, formatter: (row, key, item) => {
          return this.getTranslated(key, row);
        }},
        { key: 'createTime', label: this.$t('crm.lead.create.createTime'),sortable:true},
        { key: 'updateTime', label: this.$t('crm.lead.create.updateTime'),sortable:true }
      ],


      // search: {
      //   search: null,
      //   type: null,
      //   status: null,
      //   leadLevel: null,
      //   dateFrom: null,
      //   dateTo: null,
      // },

      // data: {
      //   total: 0,
      //   list: []
      // },

      // pagination: {
      //   currentPage: 1,
      //   perPage: 20
      // },

      // fileds: [
      //   { key: 'type', label: this.$t('crm.lead.create.type'), class: '' },
      //   { key: 'dateOfContact', label: this.$t('crm.lead.create.dateOfContact') },
      //   { key: 'name', label: this.$t('crm.lead.create.name') },
      //   { key: 'status', label: this.$t('crm.lead.create.status') },
      //   { key: 'createTime', label: this.$t('crm.lead.create.createTime') },
      //   { key: 'updateTime', label: this.$t('crm.lead.create.updateTime') }
      // ],

      busy: false,
      timeout: null,
      shouldShowSuccessMessage: this.createSuccess
    }
  },

  props: {
    createSuccess: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    permissionLevel(){
      return this.$store.state.permissionLevel;
    },
    ...mapGetters(['getTranslatedArray']),

    // ...mapGetters('Crm', [
    //   'getTranslated'
    // ]),

    // total() {
    //   return `${this.$t('crm.lead.page')} ${this.pagination.currentPage} / ${this.$t('crm.lead.total')} ${this.data.total} ${this.$t('crm.lead.items')}`;
    // },

    // leadLevels() {
    //   let options = this.getTranslated(this.$i18n.locale, 'leadLevel');
    //   options = this.addGeneralAll(options);
    //   return options;
    // },

    // leadTypes() {
    //   let options = this.getTranslated(this.$i18n.locale, 'type');
    //   options = this.addGeneralAll(options);
    //   return options;
    // },

    // leadStatus() {
    //   let options = this.getTranslated(this.$i18n.locale, 'status');
    //   options = this.addGeneralAll(options);
    //   return options;
    // }
  },

  watch: {
    pagination: {
      deep: true,
      handler(val) {
        this.refreshPage();
      }
    },

    search: {
      handler(val) {
        if (this.busy) {
          return;
        }

        Vue.set(this, 'busy', true);
        if (timeout) {
          clearTimeout(this.timeout);
        }

        let timeout = setTimeout(() => {
          Vue.set(this, 'busy', false);
          Vue.set(this, 'timeout', null);
        }, 1500);

        var result = {};
        Object.keys(this.search).forEach((key) => {
          if (this.search[key] != null &&
            this.search[key].trim().length > 0) {
            result[key] = this.search[key];
          }
        });

        this.refreshPage(result);
      },
      deep: true // watch nested
    }
  },

  methods: {
    onRowClicked(row) {
      console.debug(row)
    },

    getTranslated(type, key) {
      if (!key) {
        return 'N/A';
      }
      let result = this.getTranslatedArray(this.$i18n.locale, 'Crm', type)
        .filter((item) => {
          return item.value === key
        });
      if (result.length > 0) {
        return result[0].text;
      }
      return 'N/A';
    },


    createNewLead() {
      this.$router.push('/crm/lead/create');
    },

    // clearFilter() {
    //   Vue.set(this, 'busy', false);

    //   Vue.set(this, 'search', {
    //     search: null,
    //     type: null,
    //     status: null,
    //     leadLevel: null,
    //     dateFrom: null,
    //     dateTo: null,
    //   });
    // },

    // addGeneralAll(options) {
    //   options.unshift({
    //     value: null,
    //     text: this.$t('general.all')
    //   });
    //   return options;
    // },

    onRowSelected(item) {
      this.$router.push({
        name: 'Create Lead',
        params: { ID: parseInt(item.ID) }
      });
    },

    // getConvertedString(key, value) {
    //   let result = this[key].filter((item) => {
    //     return item.value === value;
    //   });

    //   if (result.length > 0) {
    //     return result[0].text;
    //   }

    //   return 'N/A';
    // },

    // onPageChanged(newPage) {
    //   Vue.set(this.pagination, 'currentPage', newPage);
    // },

    // refreshPage(param = {}) {
    //   this.$store.dispatch('Crm/getLeadList', {
    //     page: this.pagination.currentPage,
    //     count: this.pagination.perPage,
    //     ...param
    //   }).then((json) => {
    //     console.debug(json);
    //     Vue.set(this, 'data', json);
    //   }).catch((err) => {
    //     console.error(err);
    //   });
    // }
  },

  created() {
    // this.$store.dispatch('getAllSelections', 'lead')
    //   .then((json) => {
    //     console.log(json)
    //     this.$store.commit({ type: 'Crm/setSelections', selection: json.data });
    //   })
    //   .catch((err) => {
    //     console.error(err);
    //   });
    // this.refreshPage();
  },

  mounted() {
    if (this.createSuccess) {
      Vue.set(this, 'shouldShowSuccessMessage', true);
      setTimeout(() => {
        Vue.set(this, 'shouldShowSuccessMessage', false);
      }, 3000);
    }
  }
}

</script>
<style>
.pointer-cursor .table tbody tr,
.pointer-cursor .table tbody td {
  cursor: pointer;
}

</style>



// WEBPACK FOOTER //
// src/Crm/components/Lead/LeadList.vue